import { Card, Col, List, Row, Typography } from 'antd';
import React from 'react';
import {Record, useListContext} from 'react-admin';
import { Link } from 'react-router-dom';
import { getFilterTextForChangeState, getTagForChangeState, getTagForRuntimeStates } from '../Common/Tags';
import FaIcon from '../Icons/FaIcon';
import { faThLarge, faUsers } from '@fortawesome/free-solid-svg-icons';

const { Title } = Typography;

const GridView = () => {
    const { ids, data, loading, displayedFilters, filterValues, setFilters, page, total, perPage, setPage, setPerPage } = useListContext();

    const tableData: Record[] = []
    ids.forEach(id => tableData.push(data[id]));
    return (

        <List
            data-cy="service-item-result-list"
            pagination={{
                pageSizeOptions: [25, 50, 100],
                onShowSizeChange: (_current, size) => setPerPage(size), showSizeChanger: true,
                total: total, pageSize: perPage, current: page, onChange: page => setPage(page),
                className: "pagination-padding",
            }}
            grid={{
                gutter: 8,
                column: 4,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 4,
                xxl: 5
            }}
            dataSource={tableData}
            loading={loading}
            style={{ margin: '8px' }}
            renderItem={(item: any) => (
                <List.Item>
                    <Link to={`/service_items/${item.id}/`}>
                        <Card hoverable bodyStyle={{ padding: '10px' }}
                            title={
                                <>
                                    <Title
                                        style={{
                                            width: '100%',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            margin: 0
                                        }}
                                        title={item.name}
                                        level={4}
                                    >
                                        {item.name}
                                    </Title>
                                    <span className='text-sm'>{item.service.name}</span>
                                </>
                            }>
                            <span className='service-item-card-text'>{getTagForRuntimeStates(item.runtime_state)}</span>
                            <Link to={`/change_instances?filter={"application_id":"${item.application.id}","service_item_id":"${item.id}","state":"${getFilterTextForChangeState(item.change_state)}"}`} >
                                <span className='service-item-card-text link'>{getTagForChangeState(item.change_state)}</span>
                            </Link>
                            <Row gutter={6}>
                                <Col>
                                    <Row gutter={6}>
                                        <Col className='text-sm'>{FaIcon(faThLarge)}</Col>
                                        <Col> <span className='service-item-card-text text-sm'> {item.application.name}</span></Col>
                                    </Row>
                                    <Row gutter={6}>
                                        <Col className='text-sm'>{FaIcon(faUsers)}</Col>
                                        <Col> <span className='service-item-card-text text-sm'> {item.service_owner_team.name}</span></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Link>
                </List.Item>
            )}
        />
    )
}


export default GridView;
